import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { delError } from "../../slices/error/ErrorSlice";

export default function Error() {
    const dispatch = useDispatch();
    const error = useSelector(state => state.error.error);
    const status = useSelector(state => state.error.status);

    useEffect(() => {
        console.log("state error:", error);
    }, [error])

    function handleClearError() {
        dispatch(delError());
    }

    let statusCode = status === 500 ? status + ": " : '';
    let outputError = statusCode + error;

    return (
        <>
            {
                error &&
                <div className="alert alert-danger alert-custom" role="alert">
                    <span className="closebtn" onClick={handleClearError}>&times;</span>
                    {outputError}
                </div>
            }
        </>
    )
}